<template>
  <div class="full-calendar-header">
    <div class="header-left">
      <slot name="header-left">
      </slot>
    </div>
    <div class="header-center">
      <span class="prev-month" @click.stop="goPrev"><img style="height: 20px;" src="@/assets/left-triangle.png"/></span>
      <span class="title">{{title}}</span>
      <span class="next-month" @click.stop="goNext"><img style="height: 20px;" src="@/assets/right-triangle.png"/></span>
    </div>
    <div class="header-right">
      <slot name="header-right">
      </slot>
    </div>
  </div>
</template>
<script type="text/babel">
// import dateFunc from './dateFunc'

export default {
  props: {
    currentYear: {},
    titleFormat: {},
    monthNames: {}
  },
  data () {
    return {
      leftArrow: '<',
      rightArrow: '>'
    }
  },
  computed: {
    title () {
      if (!this.currentYear) return
      return this.currentYear
      // return this.currentYear.locale('en').format('YYYY年 M月')
    }
  },
  methods: {
    goPrev () {
      let newYear = this.currentYear - 1
      this.$emit('change', newYear)
    },
    goNext () {
      var newYear = this.currentYear + 1
      this.$emit('change', newYear)
    }
  }
}
</script>
<style lang="scss" scoped>
.full-calendar-header{
  display: flex;
  align-items: center;
  .header-left,.header-right{
    flex:1;
  }
  .header-center{
    flex:2;
    text-align:center;
    font-size: 28px;
    .title{
      margin: 0 50px;
    }
    .prev-month,.next-month{
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/headerYear.vue